/**
 * Utility for handling authentication redirects
 */

/**
 * Get the return URL from localStorage or use a default
 */
export const getReturnUrl = (defaultPath = '/dashboard'): string => {
  const savedPath = localStorage.getItem('authRedirectPath');
  
  // Only allow relative paths starting with / for security
  if (savedPath && savedPath.startsWith('/')) {
    // Clear the stored path after retrieving it
    localStorage.removeItem('authRedirectPath');
    return savedPath;
  }
  
  return defaultPath;
};

/**
 * Redirect after authentication, using localStorage for the return path
 */
export const redirectAfterAuth = (navigate: (path: string) => void, defaultPath = '/dashboard'): void => {
  const returnUrl = getReturnUrl(defaultPath);
  console.log('returnUrl', returnUrl);
  navigate(returnUrl);
}; 